/**
 * Erro de resposta HTTP com o status preservado. Existe para que o consumidor
 * decida por `instanceof` + `status`, e não por casting nem por casar texto da
 * mensagem — que muda com o idioma e com o corpo devolvido pelo backend.
 *
 * `esperarSegundos` carrega o `Retry-After` quando o servidor o envia (429/503).
 *
 * `codigo` é o `error.code` do corpo do core-api, que separa causas distintas sob
 * um mesmo status.
 */
export class ErroHttp extends Error {
  readonly status: number;
  readonly esperarSegundos: number | null;
  readonly codigo: string | null;

  constructor(
    mensagem: string,
    status: number,
    esperarSegundos: number | null = null,
    codigo: string | null = null,
  ) {
    super(mensagem);
    this.name = 'ErroHttp';
    this.status = status;
    this.esperarSegundos = esperarSegundos;
    this.codigo = codigo;
  }
}

export function ehErroHttp(erro: unknown, status?: number): erro is ErroHttp {
  if (!(erro instanceof ErroHttp)) return false;
  return status === undefined || erro.status === status;
}

export function temCodigoHttp(erro: unknown, codigo: string): boolean {
  return erro instanceof ErroHttp && erro.codigo === codigo;
}

export const TETO_RETRY_AFTER_SEGUNDOS = 300;

export function lerRetryAfterSegundos(headers: Headers | undefined): number | null {
  const bruto = headers?.get('retry-after');
  if (!bruto) return null;
  const comTeto = (segundos: number) => Math.min(segundos, TETO_RETRY_AFTER_SEGUNDOS);
  const segundos = Number(bruto);
  if (Number.isFinite(segundos)) {
    return segundos < 0 ? null : comTeto(Math.ceil(segundos));
  }
  const instante = Date.parse(bruto);
  if (Number.isNaN(instante)) return null;
  return comTeto(Math.max(0, Math.ceil((instante - Date.now()) / 1000)));
}
